export default "__VITE_ASSET__a4379f99__"